var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.354,
    height: 33.087,
    viewBox: "0 0 23.354 33.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-pause",
    "data-name": "Icon ionic-ios-pause",
    transform: "translate(-9 -6.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2405",
    "data-name": "Trac\\xE9 2405",
    d: "M14.055,39.837H9.57c-.316,0-.57-.372-.57-.827V7.577c0-.455.253-.827.57-.827h4.486c.316,0,.57.372.57.827V39.01C14.625,39.464,14.372,39.837,14.055,39.837Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2406",
    "data-name": "Trac\\xE9 2406",
    d: "M26.43,39.837H21.945c-.316,0-.57-.372-.57-.827V7.577c0-.455.253-.827.57-.827H26.43c.316,0,.57.372.57.827V39.01C27,39.464,26.747,39.837,26.43,39.837Z",
    transform: "translate(5.354 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pauseIcon.b6bda84310a146b9b367dacd4f55f51a.svg";
export { ForwardRef as ReactComponent };